import { createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "AgeGate-inner" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "AgeGate-logo" }, [
  /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 190 66" }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#i-logo" })
  ])
], -1)
const _hoisted_3 = { class: "AgeGate-form-instruction text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_FocusTrap = _resolveComponent("FocusTrap")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'is-active': _ctx.isActive, 'is-out': _ctx.isOut }, "AgeGate"]),
      ref: "ageGate"
    }, [
      _createVNode(_component_FocusTrap, { active: _ctx.isActive }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("form", {
              class: "AgeGate-form",
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([{ 'is-error': _ctx.isError}, "AgeGate-form-line"])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "data-fixed": "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
                  onKeypress: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
                  onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
                  onChange: _cache[3] || (_cache[3] = ($event: any) => {if(parseInt(_ctx.month,10)<10)_ctx.month='0'+_ctx.month;}),
                  type: "number",
                  min: "1",
                  max: "12",
                  size: "2",
                  placeholder: "MM",
                  required: "",
                  minlength: "2",
                  maxlength: "2",
                  spellcheck: "false",
                  autocorrect: "off",
                  class: "AgeGate-form-input h1"
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.month,
                    void 0,
                    { lazy: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "data-fixed": "",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.day) = $event)),
                  onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
                  onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => {if(parseInt(_ctx.day,10)<10)_ctx.day='0'+_ctx.day;}),
                  ref: "day",
                  type: "number",
                  min: "1",
                  max: "31",
                  size: "2",
                  placeholder: "DD",
                  required: "",
                  minlength: "2",
                  maxlength: "2",
                  spellcheck: "false",
                  autocorrect: "off",
                  class: "AgeGate-form-input h1"
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.day,
                    void 0,
                    { lazy: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  "data-fixed": "",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.year) = $event)),
                  onKeypress: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
                  ref: "year",
                  type: "number",
                  min: "1900",
                  max: "3000",
                  size: "4",
                  placeholder: "YYYY",
                  required: "",
                  minlength: "4",
                  maxlength: "4",
                  spellcheck: "false",
                  autocorrect: "off",
                  class: "AgeGate-form-input h1"
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.year,
                    void 0,
                    { lazy: true }
                  ]
                ])
              ], 2),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('age-gate.description')), 1),
              _createVNode(_component_ButtonHover, {
                type: "submit",
                class: _normalizeClass([{ 'is-error': _ctx.isError }, "AgeGate-form-button button button--white"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('age-gate.cta')), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ], 32)
          ])
        ]),
        _: 1
      }, 8, ["active"])
    ], 2)
  ]))
}